import { useRef, useState, useEffect, useContext, useMemo } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Layout from "../../components/layout"
import { Header, Content, WrapperSmallGap, GlassCard } from "./style"
import Input from "../../components/Input"
import Pagination from "../../components/pagination"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import MethodologyModal from "../../components/modals/MethodologyModal"
import Coa from "../../components/coA"
import ItemPreviewDrawer from "./ItemPreviewDrawer"
import { getGalleryApi, getProteinFiltersApi, getProductsWithHandleApi } from '../../api'
import { AuthContext } from '../../context/auth'
import { useDebounce } from 'use-debounce'
import { Checkbox } from '../../components/Checkbox'
import { proteinsList as allProteinList, resolutionsFilters, dyeFilters, secondaryAntibodiesFilters, primaryTypeFilters, primaryVariantTypeFilters } from '../../utils/proteinName'
import { Footer } from '../../components/Footer'
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { isVideoFile, getMp4Url, isGif } from '../../utils/videoHelper'
import { methodologyShortName } from '../../utils/methodology'
import Skeleton from "react-loading-skeleton";
import List from './List'

const galleryTabs = [
    {
        label: "Identifyn® SRM Alexa Fluor™ Secondary Fluorescent Antibodies",
        value: "alexafluor",
        status: true
    },
    {
        label: "Primary Antibodies",
        value: "primary",
        status: true
    },
    {
        label: "Identifyn® SRM Alexa Fluor™ Conjugated Primary Antibodies",
        value: "primary_conjugate",
        status: true
    },
    {
        label: "Western Blots",
        value: "western",
        status: true
    },
    {
        label: "Flow Cytometry",
        value: "flow_cytometry",
        status: true
    },
    // {
    //     label: "Multiplex (Coming Soon)",
    //     value: "multiplex",
    //     status: false
    // }
]

const Index = () => {
    const navigate = useNavigate()
    const { slug, method } = useParams()
    const dropdownRef = useRef(null)
    const coARef = useRef(null)
    const counter = useRef(0);

    // const { setIsLoading, isLoading } = useContext(AuthContext);
    const [openMethodologyModal, setOpenMethodologyModal] = useState(false)
    const [images, setImages] = useState({})
    const [currentPage, setCurrentPage] = useState(0);
    const [search, setSearch] = useState('')
    const [proteinSearch, setProteinSearch] = useState('')
    const [proteinsList, setProteinsList] = useState([])
    const [tempProteinsList, setTempProteinsList] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [modalName, setModalName] = useState(null)
    const [openFilter, setOpenFilter] = useState(false)
    const [filters, setFilters] = useState({
        proteinTarget: {
            dropDown: true,
            selectedOptions: [],
        },
        conjugateType: {
            dropDown: true,
            selectedOptions: [],
        },
        dye: {
            dropDown: true,
            selectedOptions: [],
        },
        resolution: {
            dropDown: true,
            selectedOptions: [],
        },
        primaryType: {
            dropDown: true,
            selectedOptions: '',
        },
        primaryVariantType: {
            dropDown: true,   
            selectedOptions: '',
        },
        secondaryAntibodies: {
            dropDown: true,
            selectedOptions: [],
        }
    })
    const [tempFilters, setTempFilters] = useState({
        proteinTarget: {
            dropDown: true,
            selectedOptions: [],
        },
        conjugateType: {
            dropDown: true,
            selectedOptions: [],
        },
        dye: {
            dropDown: false,
            selectedOptions: [],
        },
        resolution: {
            dropDown: false,
            selectedOptions: [],
        },
        primaryType: {
            dropDown: true,
            selectedOptions: '',
        },
        primaryVariantType: {
            dropDown: true,
            selectedOptions: '',
        },
        secondaryAntibodies: {
            dropDown: true,
            selectedOptions: '',
        }
    })
    const [filterApplied, setFilterApplied] = useState(false)
    const [debouncedSearch] = useDebounce(search, 500);
    const [previewProduct, setPreviewProduct] = useState(null)
    const [openItemPreviewModal, setOpenItemPreviewModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [productType, setProductType] = useState("alexafluor")
    const [viewType, setViewType] = useState("grid")

    useEffect(() => {
        fetchProteinFilters()
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenFilter(false)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, []);


const isValidSlug = (slug) => {
  const slugRegex = /^[a-z0-9]+(-[a-z0-9]+)*$/;
  return slugRegex.test(slug);
}

    const fetchProductWithSlug = (slug) => {
       setIsLoading(true)
       if (isValidSlug(slug)) {
       getProductsWithHandleApi(slug).then(res => {
           if (res && res.data && res.data?.products?.length) {
               setPreviewProduct(res?.data?.products[0])
               setSelectedProduct(res?.data?.products[0])
               const imgs = res.data?.products[0]?.metadata?.images
               if (method){
                const methodName = method?.toLocaleLowerCase()?.replace(/\s/g, '-')
                const methodologyName = methodologyShortName[methodName] 
                if (imgs && imgs.some(image => image.name === methodologyName ? methodologyName : method)) {
                    setModalName(methodologyName ? methodologyName : method)
                    setOpenMethodologyModal(true)
                }else{
                    setModalName('')
                    setOpenMethodologyModal(false)
                    navigate('/product-search')
                }
               } else {
                setOpenItemPreviewModal(true)
               }
           } else {
            navigate('/product-search')
           }
           setIsLoading(false)    
       }).catch(err => {
           setIsLoading(false)
       })
    } else {
        navigate('/product-search')
    }
    }

    const fetchGallery = () => {
        setIsLoading(true)
        const { proteinTarget, conjugateType, dye, resolution, secondaryAntibodies, primaryType, primaryVariantType } = filters
        const selectedProteins = proteinTarget.selectedOptions?.map(item => item).join(",")
        // const selectedConjugates = conjugateType.selectedOptions?.map(item => item === 'Primary Conjugate' ? 'PA-MM,PA-MR,PA-RR,PA-RP,PA-RTM,DC' : 'SA').join(",")
        const containsControl = dye.selectedOptions?.includes('Control')
        const selectedDyes = dye.selectedOptions?.filter(item => item !== 'Control').map(item => item).join(",")
        const selectedResolutions = containsControl ? [...resolution.selectedOptions, 'Control'].join(",") : resolution.selectedOptions?.map(item => item).join(",")
        const selectedHost = extractAndCombinePayload([primaryType?.selectedOptions, ...secondaryAntibodies?.selectedOptions])?.host
        const selectedSpecies = extractAndCombinePayload(secondaryAntibodies?.selectedOptions)?.species_reactivity
        const selectedChain = extractAndCombinePayload(secondaryAntibodies?.selectedOptions)?.chain_specification
        const selectedClonality = extractAndCombinePayload(primaryType?.selectedOptions, true)?.clonality
        const selectedProteinVariantType = primaryVariantType.selectedOptions
        const selectedViewType = viewType

        const payload = {
            view: selectedViewType,
            subtitle: selectedProteins,
            type: productType === 'alexafluor' ? 'SA' : productType === 'primary' ? 'PA-MM,PA-MR,PA-RR,PA-RP,PA-RTM' : productType === 'primary_conjugate' ? 'DC' : "",
            ...(productType !== 'primary' &&  {dyes: selectedDyes}),
            application: productType === 'western' ? 'Western Blotting' : productType === 'flow_cytometry' ? 'Flow Cytometry' : selectedResolutions,
            host: selectedHost,
            ...(!['primary', 'primary_conjugate'].includes(productType) && { species_reactivity: selectedSpecies }),
            ...(!['primary', 'primary_conjugate'].includes(productType) && { chain_specification: selectedChain }),
            ...(!['alexafluor'].includes(productType) && { variant: selectedProteinVariantType }),
            ...(!['alexafluor'].includes(productType) && { clonality: selectedClonality })
        };

        const params = Object.keys(payload).length > 0
            ? '&' + Object.entries(payload)
                .map(([key, value]) => `${key}=${value}`)
                .join('&')
            : '';

        getGalleryApi(30, currentPage + 1, debouncedSearch, params).then(res => {
            if (res && res.data && res.data) {
                setImages(res?.data)
                setTimeout(() => {
                    setIsLoading(false)
                }, 2500)
            } else {
                setImages({})
                setIsLoading(false)
            }
        })
    }

    const fetchProteinFilters = () => {
        setIsLoading(true)
        getProteinFiltersApi().then(res => {
            if (res && res?.data && res?.data?.proteins_available) {
                setProteinsList(res?.data?.proteins_available)
                setIsLoading(false)
            } else {
                setProteinsList(allProteinList)
                setIsLoading(false)
            }
        }).catch(() => {
            setIsLoading(false)
            setProteinsList(allProteinList)
        })
    }


    useEffect(() => {
        fetchGallery()
        document.getElementById('gallery-grid').scrollIntoView({ block: 'center', behavior: 'smooth' });
        counter.current = 0;
    }, [currentPage, debouncedSearch, filters, productType, viewType])


    useEffect(() => {
        if (proteinSearch) {
            const filteredOptions = proteinsList.filter((option) => {
                return option.toLowerCase().includes(proteinSearch.toLowerCase())
            })
            setTempProteinsList(filteredOptions)
        } else {
            setTempProteinsList(proteinsList)
        }

    }, [proteinsList, proteinSearch])

    useEffect(() => {
        if(slug) {
            fetchProductWithSlug(slug)
        }
    },[slug])

    const imageLoaded = () => {
        counter.current += 1;
        if (counter.current >= images?.products?.length - 1) {
            setIsLoading(false);
        }
    }


    useEffect(() => {
        if (openFilter || openMethodologyModal || openItemPreviewModal) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    }, [openFilter, openMethodologyModal, openItemPreviewModal])


    useEffect(() => {
        setFilterApplied(Object.values(filters).reduce((total, field) => total + field.selectedOptions.length, 0) > 0 ? true : false)
    }, [filters])

    const TotalSelectedFilters = (filters) => {
        return Object.values(filters).reduce((total, field) => {
            if (Array.isArray(field.selectedOptions)) {
                return total + field.selectedOptions.length;
            } else if (typeof field.selectedOptions === 'string' && field.selectedOptions.trim()) {
                return total + 1;
            }
            return total;
        }, 0);
    }


    const extractAndCombinePayload = (data, string=false) => {
        let hosts = new Set();
        let speciesReactivities = new Set();
        let chainSpecifications = new Set();
        let clonality = new Set();
        if (data?.length && !string) {
            data.forEach((item) => {
                const parts = item.split('&');
                parts.forEach((part) => {
                    const [key, value] = part.split('=');
                    if (key === 'species_reactivity') {
                        speciesReactivities.add(value);
                    } else if (key === 'chain_specification') {
                        chainSpecifications.add(value);
                    } else if (key === 'host') {
                        hosts.add(value);
                    }
                });
            });
        }
    
        if (string) {
            const parts = data.split('&');
            parts.forEach((part) => {
                const [key, value] = part.split('=');
                if (key === 'host') {
                    hosts.add(value);
                } else if (key === 'clonality') {
                    clonality.add(value);
                }
            });
        }
    
        const hostsArray = Array.from(hosts);
        const speciesReactivitiesArray = Array.from(speciesReactivities);
        const chainSpecificationsArray = Array.from(chainSpecifications);
        const clonalityArray = Array.from(clonality);
    
        const PayloadData = {
            host: hostsArray.join(', '),
            species_reactivity: speciesReactivitiesArray.join(', '),
            chain_specification: chainSpecificationsArray.join(', '),
            clonality: clonalityArray.join(', '),
        };
    
        return PayloadData;
    };
    
    



    return (
        <Layout 
         meta={{
            title: (slug && method) ? `${methodologyShortName[method?.toLocaleLowerCase()?.replace(/\s/g, '-')]}-${selectedProduct?.title ?? ''}` : slug ? `${selectedProduct?.title}` : 'Gallery'
            }}>
            <Header>
            <WrapperSmallGap flexDirection="row" width={'50%'} justifyContent={"start"} alignItems={"start"} marginBottom={'40px'} marginBottomMobile={'0'}>
               <GlassCard alignItems='start'>
                <h4>Identifyn’s™ Product Gallery Filter Allows Fine Tuning Your Applicaiton Across Resolutions Ranging From Widefield to Super Resolution and Single Molecule Applications</h4>
                        <h4>No More Troubleshooting Identifyn® Provides:</h4>
                <WrapperSmallGap flexDirection={'row'} gap={'5px'} flexDirectionMobile={'row'}>
                    <img src={toAbsoluteUrl("/media/antibody.png")} alt="antibody" style={{ width:'24px', alignItems:'start'}} />
                    <h4>Sample Preparation Methodology</h4>
                </WrapperSmallGap>
                <WrapperSmallGap flexDirection={'row'} gap={'5px'} flexDirectionMobile={'row'}>
                    <img src={toAbsoluteUrl("/media/antibody.png")} alt="antibody" style={{ width:'24px', alignItems:'start'}}  />
                    <h4>Optical Instrumentation and Settings Used in Image Acquisition</h4>
                </WrapperSmallGap>
                <WrapperSmallGap flexDirection={'row'} gap={'5px'} flexDirectionMobile={'row'}>
                    <img src={toAbsoluteUrl("/media/antibody.png")} alt="antibody" style={{ width:'24px', alignItems:'start'}}  />
                    <h4>Post Processing Details for Structured Illumination, Airyscan, and STORM.</h4>
                </WrapperSmallGap>
               </GlassCard>
            </WrapperSmallGap>
            <WrapperSmallGap flexDirection="row" justifyContent="center" alignItems="center" textAlign={'center'} width={'90%'} marginAuto={'auto'} display='grid'>
                <GlassCard textAlign={'center'} padding={'16px'}>
                    <h3>Primary Antibodies</h3>
                </GlassCard>
                <GlassCard textAlign={'center'} padding={'16px'}>
                        <h3>Identifyn® SRM Alexa Fluor™ Direct Conjugates</h3>
                </GlassCard>
                <GlassCard textAlign={'center'} padding={'16px'}>
                        <h3>Identifyn® SRM Alexa Fluor™ Secondary</h3>
                </GlassCard>
            </WrapperSmallGap>
            </Header>
            <Content>
                <div className="gallery-tab-container">
                    {galleryTabs.map((item, index) => {
                        return (
                            <button className={productType === item.value && 'tab-active'}
                            disabled={!item.status}
                            onClick={() => {
                            setProductType(item.value)
                            setFilters({
                                proteinTarget: {
                                    dropDown: filters.proteinTarget.dropDown,
                                    selectedOptions: [],
                                },
                                conjugateType: {
                                    dropDown: filters.conjugateType.dropDown,
                                    selectedOptions: [],
                                },
                                dye: {
                                    dropDown: filters.dye.dropDown,
                                    selectedOptions: [],
                                },
                                resolution: {
                                    dropDown: filters.resolution.dropDown,
                                    selectedOptions: [],
                                },
                                primaryType: {
                                    dropDown: filters.primaryType.dropDown,
                                    selectedOptions: '',
                                },
                                primaryVariantType: {
                                    dropDown: filters.primaryVariantType.dropDown,   
                                    selectedOptions: '',
                                },
                                secondaryAntibodies: {
                                    dropDown: filters.secondaryAntibodies.dropDown,
                                    selectedOptions: '',
                                }
                            })
                            setProteinSearch('')
                            setCurrentPage(0)
                        }}
                    >{item.label}</button>
                    )
                    })}
                </div>
                <div className="header-content">
                    <div className='filter-btn'>
                        <WrapperSmallGap flexDirection={'row'} gap={'10px'} alignItems={'center'} alignItemMobile={'start'} justifyContent={'start'}>
                        <button className='btn'
                            style={{ background: openFilter && 'rgba(255, 141, 36, 0.28)', width:'fit-content' }}
                            onClick={() => setOpenFilter(!openFilter)}
                        >{TotalSelectedFilters(filters) > 0 ? <img src={toAbsoluteUrl('/media/filterapplied.png')} style={{ width: '20px'}} alt='' /> : <i className='fal fa-filter' />}All Filters {TotalSelectedFilters(filters) > 0 ? `(${TotalSelectedFilters(filters)})` : ''}</button>
                        <h5><em>Filter by Antibody, Dye, and Resolution</em></h5>
                        </WrapperSmallGap>
                        {openFilter && <div className="filter-dropdown" ref={dropdownRef}>
                            <div className="filter-dropdown-container">
                                <div className="filter-header">
                                    <h3>Filters</h3>
                                    {(Object.values(filters).some(filter => filter.selectedOptions?.length > 0)) && <h6 style={{ cursor: 'pointer', color: 'var(--primary-color)', fontWeight: 600 }}
                                        onClick={() => {
                                            setFilters({
                                                proteinTarget: {
                                                    dropDown: filters.proteinTarget.dropDown,
                                                    selectedOptions: [],
                                                },
                                                conjugateType: {
                                                    dropDown: filters.conjugateType.dropDown,
                                                    selectedOptions: [],
                                                },
                                                dye: {
                                                    dropDown: filters.dye.dropDown,
                                                    selectedOptions: [],
                                                },
                                                resolution: {
                                                    dropDown: filters.resolution.dropDown,
                                                    selectedOptions: [],
                                                },
                                                primaryType: {
                                                    dropDown: filters.primaryType.dropDown,
                                                    selectedOptions: '',
                                                },
                                                primaryVariantType: {
                                                    dropDown: filters.primaryVariantType.dropDown,   
                                                    selectedOptions: '',
                                                },
                                                secondaryAntibodies: {
                                                    dropDown: filters.secondaryAntibodies.dropDown,
                                                    selectedOptions: '',
                                                }
                                            })
                                            setProteinSearch('')
                                            setCurrentPage(0)
                                        }}
                                    >Reset All</h6>
                                    }
                                </div>
                                {(productType !== 'alexafluor') && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                proteinTarget: {
                                                    ...prevFilters.proteinTarget,
                                                    dropDown: !prevFilters.proteinTarget.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Protein Target {filters?.proteinTarget?.selectedOptions.length > 0 && <span>{filters?.proteinTarget?.selectedOptions.length}</span>}</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.proteinTarget?.selectedOptions.length > 0 && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        proteinTarget: {
                                                            ...prevFilters.proteinTarget,
                                                            selectedOptions: []
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.proteinTarget?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.proteinTarget?.dropDown && <Input type='text' placeholder='Search' clear={proteinSearch} onClear={() => setProteinSearch('')} search style={{ width: '100%', height: '40px', paddingLeft: '30px' }} value={proteinSearch} onChange={(e) => setProteinSearch(e.target.value)} />}
                                    {filters?.proteinTarget?.dropDown && <div className="filter-type-container" style={{ maxHeight: tempProteinsList.length > 0 ? '300px' : '300px' }}>
                                        {tempProteinsList.length > 0 ? tempProteinsList?.map((item) => {
                                            return <div className="two-column">
                                                <Checkbox label={item} value={item} checked={filters.proteinTarget.selectedOptions.includes(item)}
                                                    onChange={() => {
                                                        if (filters.proteinTarget.selectedOptions.includes(item)) {
                                                            setFilters(prevFilters => ({
                                                                ...prevFilters,
                                                                proteinTarget: {
                                                                    ...prevFilters.proteinTarget,
                                                                    selectedOptions: filters.proteinTarget.selectedOptions.filter(option => option !== item)
                                                                }
                                                            }))
                                                            setCurrentPage(0)
                                                        } else {
                                                            setFilters(prevFilters => ({
                                                                ...prevFilters,
                                                                proteinTarget: {
                                                                    ...prevFilters.proteinTarget,
                                                                    selectedOptions: [...prevFilters.proteinTarget.selectedOptions, item]
                                                                }
                                                            }))
                                                            setCurrentPage(0)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        })
                                            : <div className='no-orders'>
                                                <span className='icon'>
                                                    <i class="fal fa-boxes"></i>
                                                </span>
                                                <p style={{ color: '#6c6a73', fontWeight: 400, fontSize: '16px' }}>There are no results. <br />Try to broaden your search.</p>
                                            </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                {!['alexafluor'].includes(productType) && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                primaryType: {
                                                    ...prevFilters.primaryType,
                                                    dropDown: !prevFilters.primaryType.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Primary Type</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.primaryType?.selectedOptions && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        primaryType: {
                                                            ...prevFilters.primaryType,
                                                            selectedOptions: ''
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.primaryType?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.primaryType?.dropDown && <div className="filter-type-container">
                                        {
                                            primaryTypeFilters.map(item => {
                                                return <div className="two-column">
                                                    <Checkbox label={item.label} value={item.value} checked={filters.primaryType.selectedOptions === item.value}
                                                        onChange={(e) => {
                                                                if (filters.primaryType.selectedOptions === item.value) {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        primaryType: {
                                                                            ...prevFilters.primaryType,
                                                                            selectedOptions: ''
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                } else {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        primaryType: {
                                                                            ...prevFilters.primaryType,
                                                                            selectedOptions: e.target.value
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                }
                                                        }}
                                                    />
                                                </div>
                                            }    
                                        )
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                {!['alexafluor'].includes(productType) && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                primaryVarinatType: {
                                                    ...prevFilters.primaryVariantType,
                                                    dropDown: !prevFilters.primaryVariantType.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Fc</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.primaryVariantType?.selectedOptions && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        primaryVariantType: {
                                                            ...prevFilters.primaryVariantType,
                                                            selectedOptions: ''
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.primaryVariantType?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.primaryVariantType?.dropDown && <div className="filter-type-container">
                                        {
                                            primaryVariantTypeFilters.map(item => {
                                                return <div className="two-column">
                                                    <Checkbox label={item.label} value={item.value} checked={filters.primaryVariantType.selectedOptions === item.value}
                                                        onChange={(e) => {
                                                                if (filters.primaryVariantType.selectedOptions === item.value) {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        primaryVariantType: {
                                                                            ...prevFilters.primaryVariantType,
                                                                            selectedOptions: ''
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                } else {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        primaryVariantType: {
                                                                            ...prevFilters.primaryVariantType,
                                                                            selectedOptions: e.target.value
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                }
                                                        }}
                                                    />
                                                </div>
                                            }    
                                        )
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                {productType === 'primarys' && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                conjugateType: {
                                                    ...prevFilters.conjugateType,
                                                    dropDown: !prevFilters.conjugateType.dropDown
                                                }
                                            }))
                                        }}
                                    >
                                        <h4>Conjugate Type {filters?.conjugateType?.selectedOptions.length > 0 && <span>{filters?.conjugateType?.selectedOptions.length}</span>}</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.conjugateType?.selectedOptions.length > 0 && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        conjugateType: {
                                                            ...prevFilters.conjugateType,
                                                            selectedOptions: []
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.conjugateType?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.conjugateType?.dropDown && <div className="filter-type-container">
                                        <div className="two-column">
                                            <Checkbox label='Primary Conjugate' value={'Primary Conjugate'} checked={filters.conjugateType.selectedOptions.includes('Primary Conjugate')}
                                                onChange={(e) => {
                                                    if (!filters.conjugateType.selectedOptions.includes('Primary Conjugate')) {
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            conjugateType: {
                                                                ...prevFilters.conjugateType,
                                                                selectedOptions: [...filters.conjugateType.selectedOptions, e.target.value]
                                                            }
                                                        }))
                                                        setCurrentPage(0)
                                                    } else {
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            conjugateType: {
                                                                ...prevFilters.conjugateType,
                                                                selectedOptions: filters.conjugateType.selectedOptions.filter(item => item !== 'Primary Conjugate')
                                                            }
                                                        }))
                                                        setCurrentPage(0)
                                                    }
                                                }} />
                                            {/* <p>70</p> */}
                                        </div>
                                        <div className="two-column">
                                            <Checkbox label='Secondary Conjugate' value={'Secondary Conjugate'} checked={filters.conjugateType.selectedOptions.includes('Secondary Conjugate')}
                                                onChange={(e) => {
                                                    if (!filters.conjugateType.selectedOptions.includes('Secondary Conjugate')) {
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            conjugateType: {
                                                                ...prevFilters.conjugateType,
                                                                selectedOptions: [...filters.conjugateType.selectedOptions, e.target.value]
                                                            }
                                                        }))
                                                        setCurrentPage(0)
                                                    } else {
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            conjugateType: {
                                                                ...prevFilters.conjugateType,
                                                                selectedOptions: filters.conjugateType.selectedOptions.filter(item => item !== 'Secondary Conjugate')
                                                            }
                                                        }))
                                                        setCurrentPage(0)
                                                    }
                                                }}
                                            />
                                            {/* <p>48</p> */}
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                                {productType !== 'primary' && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                dye: {
                                                    ...prevFilters.dye,
                                                    dropDown: !prevFilters.dye.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Dye {filters?.dye?.selectedOptions.length > 0 && <span>{filters?.dye?.selectedOptions.length}</span>}</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.dye?.selectedOptions.length > 0 && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        dye: {
                                                            ...prevFilters.dye,
                                                            selectedOptions: []
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.dye?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.dye?.dropDown && <div className="filter-type-container">
                                        {
                                            dyeFilters.map(item => {
                                                if(productType === 'western' && item.value === 'Control') return null
                                                return <div className="two-column">
                                                    <Checkbox label={item.label} value={item.value} checked={filters.dye.selectedOptions.includes(item.value)}
                                                        onChange={(e) => {
                                                            if (!filters.dye.selectedOptions.includes(item.value)) {
                                                                setFilters(prevFilters => ({
                                                                    ...prevFilters,
                                                                    dye: {
                                                                        ...prevFilters.dye,
                                                                        selectedOptions: [...filters.dye.selectedOptions, e.target.value]
                                                                    }
                                                                }))
                                                                setCurrentPage(0)
                                                            } else {
                                                                setFilters(prevFilters => ({
                                                                    ...prevFilters,
                                                                    dye: {
                                                                        ...prevFilters.dye,
                                                                        selectedOptions: filters.dye.selectedOptions.filter(_i => _i !== item.value)
                                                                    }
                                                                }))
                                                                setCurrentPage(0)
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            }    
                                        )
                                        }
                                    </div>
                                    }
                                </div>
                                }
                                {productType !== 'western' && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                resolution: {
                                                    ...prevFilters.resolution,
                                                    dropDown: !prevFilters.resolution.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Resolution {filters?.resolution?.selectedOptions.length > 0 && <span>{filters?.resolution?.selectedOptions.length}</span>}</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.resolution?.selectedOptions.length > 0 && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        resolution: {
                                                            ...prevFilters.resolution,
                                                            selectedOptions: []
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.resolution?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.resolution?.dropDown && <div className="filter-type-container">
                                        {resolutionsFilters?.map(item => (
                                            <div className="two-column">
                                                <Checkbox label={item.label} value={item.value} checked={filters.resolution.selectedOptions.includes(item.value)}
                                                    onChange={(e) => {
                                                        if (!filters.resolution.selectedOptions.includes(item.value)) {
                                                            setFilters(prevFilters => ({
                                                                ...prevFilters,
                                                                resolution: {
                                                                    ...prevFilters.resolution,
                                                                    selectedOptions: [...filters.resolution.selectedOptions, e.target.value]
                                                                }
                                                            }))
                                                            setCurrentPage(0)
                                                        } else {
                                                            setFilters(prevFilters => ({
                                                                ...prevFilters,
                                                                resolution: {
                                                                    ...prevFilters.resolution,
                                                                    selectedOptions: filters.resolution.selectedOptions.filter(_i => _i !== item.value)
                                                                }
                                                            }))
                                                            setCurrentPage(0)
                                                        }
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    }
                                </div>
                                }
                                {(productType === 'alexafluor' || productType === 'western') && <div className="filter-types">
                                    <div className="filter-type-header" style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                secondaryAntibodies: {
                                                    ...prevFilters.secondaryAntibodies,
                                                    dropDown: !prevFilters.secondaryAntibodies.dropDown
                                                }
                                            }))

                                        }}
                                    >
                                        <h4>Secondary Antibodies {filters?.secondaryAntibodies?.selectedOptions.length > 0 && <span>{filters?.secondaryAntibodies?.selectedOptions.length}</span>}</h4>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {filters?.secondaryAntibodies?.selectedOptions?.length > 0 && <i className='far fa-times' style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setFilters(prevFilters => ({
                                                        ...prevFilters,
                                                        secondaryAntibodies: {
                                                            ...prevFilters.secondaryAntibodies,
                                                            selectedOptions: ''
                                                        }
                                                    }))
                                                    setCurrentPage(0)
                                                }}
                                            />
                                            }
                                            <i className={`far ${filters?.secondaryAntibodies?.dropDown ? 'fa-angle-up' : 'fa-angle-down'}`} style={{ color: 'var(--primary-color)', cursor: 'pointer' }}
                                            />
                                        </div>
                                    </div>
                                    {filters?.secondaryAntibodies?.dropDown && <div className="filter-type-container" style={{gap:'16px'}}>
                                        {secondaryAntibodiesFilters?.map(item => (
                                            <div className='subfilter-type-container'>
                                                <h4>{item.name}</h4>
                                                {item.subFilters?.map(subItem => (
                                                    <div className="two-column">
                                                        <Checkbox label={subItem.label} value={subItem.value} checked={filters.secondaryAntibodies.selectedOptions.includes(subItem.value)}
                                                            onChange={(e) => {
                                                                if (!filters.secondaryAntibodies.selectedOptions.includes(subItem.value)) {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        secondaryAntibodies: {
                                                                            ...prevFilters.secondaryAntibodies,
                                                                            selectedOptions: [...filters.secondaryAntibodies.selectedOptions, e.target.value]
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                } else {
                                                                    setFilters(prevFilters => ({
                                                                        ...prevFilters,
                                                                        secondaryAntibodies: {
                                                                            ...prevFilters.secondaryAntibodies,
                                                                            selectedOptions: filters.secondaryAntibodies.selectedOptions.filter(_i => _i !== subItem.value)
                                                                        }
                                                                    }))
                                                                    setCurrentPage(0)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            <hr style={{ height: '1px', background: '#EDEDED' }} />
                            <div className="filter-btn-container">
                                <button className="cancel-btn btn"
                                    onClick={() => {
                                        setOpenFilter(false)
                                    }}
                                >Cancel</button>
                                <button className="btn"
                                    onClick={() => {
                                        setOpenFilter(false)
                                        // setFilterApplied(Object.values(filters).reduce((total, field) => total + field.selectedOptions.length, 0) > 0 ? true : false)
                                        // setTempFilters(filters)
                                    }}
                                >Show {TotalSelectedFilters(filters) > 0 ? `(${TotalSelectedFilters(filters)})` : 'All'}</button>
                            </div>
                        </div>
                        }
                    </div>
                    <WrapperSmallGap flexDirection={'row'} gap={'10px'} alignItems={'center'} alignItemMobile={'end'} justifyContent={'start'} width={'auto'} widthMobile={'auto'} >
                    <div className="view-tab-container">
                    <button className={viewType === "grid" && 'tab-active'} onClick={() => setViewType("grid")}><i class="fas fa-images"></i> Grid View</button>
                    <button className={viewType === "list" && 'tab-active'} onClick={() => setViewType("list")}><i class="fal fa-bars"></i> List View</button>
                    </div>
                    <h5><span>{images.totalcount}</span> {`${viewType === "grid" ? images.totalcount > 1 ? 'Images' : 'Image' : images.totalcount > 1 ? 'Products' : 'Product'}`}</h5>
                    </WrapperSmallGap>
                </div>
                {filterApplied && <div className="filters-applied-container">
                    {search && <div className="filters">
                        <span>Search:</span> {search} <i className='fal fa-times' onClick={() => setSearch('')}></i>
                    </div>
                    }
                    {Object.entries(filters).map(([parentName, { selectedOptions }]) => {
                        const options = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions].filter(Boolean);
                        if (options.length > 0) {
                            return (
                                <div key={parentName} className="filters">
                                    <span>{parentName === 'dye' ? 'Dye' : parentName === 'proteinTarget' ? 'Protein Target' : parentName === 'conjugateType' ? 'Conjugate Type' : parentName === 'secondaryAntibodies'
                                        ? 'Secondary Antibodies' : parentName === 'resolution' ? 'Resolution' : parentName === 'primaryType' ? 'Type' : parentName === 'primaryVariantType' && 'Fc' }:</span>
                                    {options.map((option, index) => {
                                        if (parentName === 'secondaryAntibodies') {
                                            option = option.replace(/host=/, '');
                                            option = option.replace(/species_reactivity=/, '');
                                            option = option.replace(/&chain_specification=/, ' ');
                                            option = option.replace('&', ' ');
                                        }
                                        if (parentName === 'primaryType') {
                                            option = option.replace(/host=/, '');
                                            option = option.replace(/clonality=/, '');
                                            option = option.replace('&', ' ');
                                        }

                                        return (
                                            <>
                                                {option}
                                                {parentName === 'dye' && option !== 'Control' && ' nm'}
                                                {index !== options.length - 1 && '; '}
                                            </>
                                        );
                                    })}
                                    <i className='fal fa-times'
                                        onClick={() => {
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                [parentName]: {
                                                    ...prevFilters[parentName],
                                                    selectedOptions: parentName === 'primaryType' || parentName === 'primaryVariantType' ? '' : [],
                                                }
                                            }))
                                            setCurrentPage(0)
                                            setTempFilters(prevFilters => ({
                                                ...prevFilters,
                                                [parentName]: {
                                                    ...prevFilters[parentName],
                                                    selectedOptions: parentName === 'primaryType' || parentName === 'primaryVariantType' ? '' : [],
                                                }
                                            }))
                                        }}
                                    ></i>
                                </div>
                            );
                        }
                        return null;
                    })
                    }
                </div>
                }
                <div id='gallery-grid'></div>
                {images && images?.products?.length > 0 && <div className={viewType === 'grid' ? 'images-grid-container' : 'list-container'} id="images-grid-container" style={{ display: isLoading ? 'flex' : 'none', background: 'transparent'}}>
                    {Array(17).fill()
                        .map((item, index) => (
                            <Skeleton key={index} height={viewType === 'grid' ? 171 : 50} width={viewType === 'grid' ? 171 : '100%'} />
                        ))
                    }
                </div>
                }
                {images && images?.products?.length > 0 ? 
                <>
                    {viewType === 'grid' ?
                    <div  className="images-grid-container" style={{ visibility: isLoading ? 'hidden' : 'visible', height: isLoading ? '0px' : 'auto' }}>
                        {images && images?.products?.map((image, i) => (
                            isVideoFile(image) ?
                                <video src={getMp4Url(image?.url)} autoPlay loop muted playsInline
                                    onClick={() => {
                                        setModalName(image?.name)
                                        setSelectedProduct({
                                            metadata: {
                                                images: [image]
                                            }
                                        })
                                        setOpenMethodologyModal(true)
                                    }}
                                />
                                : 
                                <div key={image.product_id + i}>
                                    {isGif(image) ?
                                        <img src={image?.url} alt=""
                                            onClick={() => {
                                                setModalName(image?.name)
                                                setSelectedProduct({
                                                    metadata: {
                                                        images: [image]
                                                    }
                                                })
                                                navigate(`/product-search/${image?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === image?.name) || image?.name}`)
                                                setOpenMethodologyModal(true)
                                            }} />
                                        :
                                        <img
                                            src={`${process.env.REACT_APP_GALLERY_URL}500:550:${image?.url?.split('.com/')[1]}`}
                                            alt=""
                                            onClick={() => {
                                                setModalName(image?.name)
                                                setSelectedProduct({
                                                    metadata: {
                                                        images: [image]
                                                    }
                                                })
                                                navigate(`/product-search/${image?.product_handle}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === image?.name) || image?.name}`)
                                                setOpenMethodologyModal(true)
                                            }}
                                        />
                                    }
                                </div>
                        ))}
                    </div>
                    :
                    <div className="list-container" style={{ visibility: isLoading ? 'hidden' : 'visible', height: isLoading ? '0px' : 'auto' }}>
                    {images && images?.products?.map((image, i) => (
                        <List 
                        key={image.product_id + i}
                        item={image} 
                        isLoading={isLoading} 
                        setIsLoading={setIsLoading}
                        setPreviewProduct={setPreviewProduct}
                        setOpenItemPreviewModal={setOpenItemPreviewModal}
                        createSlug={true}
                         />
                    ))}
                    </div>
                    }
                    {images?.totalcount / images.limit > 1 && <Pagination total={images?.totalcount / images.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
                </>
                    : <div className='no-orders'>
                        <span className='icon'>
                            <i class="far fa-image"></i>
                        </span>
                        <p>No Images Yet.</p>
                    </div>
                }
            </Content>
            <p className='container' style={{ margin: '0px 0 16px 0' }} id='gallery'>Identifyn® humbly wishes that this collective enables the global academic and non-profit research community. <br /> <br />
                    Copy or redistribution of these images, methods, acquisition parameters, or general presentation for commercial use by for-profit entities is prohibited without prior written consent, or express license.
            </p>
            <Footer />
            <div className="print-map" style={{ display: 'none' }}>
                <Coa reference={coARef} selectedProduct={previewProduct} productCategory={previewProduct?.mid_code?.search("PA") >= 0 ? 'PA' : previewProduct?.mid_code?.search("SA") >= 0 ? 'SA' : 'DC'} />
            </div>
            {openMethodologyModal && <MethodologyModal setOpenMethodologyModal={setOpenMethodologyModal} selectedProduct={selectedProduct} modalName={modalName} setModalName={setModalName} galleryView={true} setPreviewProduct={setPreviewProduct} setOpenItemPreviewModal={setOpenItemPreviewModal} createSlug={true} />}
            {openItemPreviewModal && <ItemPreviewDrawer previewProduct={previewProduct} setPreviewProduct={setPreviewProduct} coARef={coARef} setOpenItemPreviewModal={setOpenItemPreviewModal} setModalName={setModalName} setSelectedProduct={setSelectedProduct} setOpenMethodologyModal={setOpenMethodologyModal} isSlug={slug} />}
        </Layout>
    )
}

export default Index